var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sale_scenario)?_c('div',{staticClass:"sale-scenario"},[_c('span',[_vm._v("Ottimo prezzo!")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }